<template>
  <div>
    <Nav v-bind:organization="organization" />
    <div class="app">
      <Sidebar />
      <div class="floating-container">
        <TimeSeries
          name="Views Per Hour (Today)"
          :series="testUserSeries"
        />
        <!-- BasicChart Types: line || bar  -->
        <BasicChart
          type="line"
          name="User Tests Per Hour (Today)"
          pointLabel="User Tests"
          :data="lineChartData"
        />
        <DataTable
          name="Top Articles"
          :columns="table.columns"
          :body="table.body"
        />
      </div>
    </div>
  </div>
</template>

<script>

import Sidebar from "./generics/Sidebar";
import Nav from "./generics/Nav";
import Table from "./generics/Table";

import DataTable from "./dataviews/DataTable";
import TimeSeries from "./dataviews/TimeSeries";
import BasicChart from "./dataviews/BasicChart";

import request from "../js/request.js";
import utils from "../js/utils.js";

export default {
  name: 'AdminView',
  data () {
    let data = {
      organization: {},
      testUserSeries: null,
      lineChartData: null,
      table: {
        columns: [
          {
            name: 'Domain',
            key: 'domain',
            width: 200,
            align: null
          },
          {
            name: 'Path',
            key: 'path',
            width: 850,
            align: 'left'
          },
          {
            name: 'Count',
            key: 'count',
            width: 80,
            align: 'right'
          },
        ],
        body: null
      },
    };
    return data;
  },
  methods: {
    async fetchOrgInfo(){
      const { organization } = await utils.generalInformation()
      this.organization = organization
    },
    async fetchTableData(){
      const {body} = await request(
        "https://testing.porticopay.com/api/v2/log/analyze/",
        { credentials: true }
      ).post({
        type: "table",
        table: "user_log",
        settings: {
          last: "1 day",
          group_by: ["domain", "path"],
          order: {
            count: "desc",
          },
          limit: 50,
        },
        query: {

        }
      })
      this.table.body = body
    },
    async fetchTimeSeriesData(){

      const d1 = await request(
        "https://testing.porticopay.com/api/v2/log/analyze/",
        { credentials: true }
      ).post({
        type: "timeseries",
        table: "user_log",
        settings: {
            last: "7 day",
            interval: "hour",
        },
        query: {},
      })

      //temp data to simulate another series
      const d2 = []
      for(const point of d1){
        d2.push([
          point[0],
          point[1] + 500
        ])
      }

      this.testUserSeries = [
        {
          name: 'Test Users',
          data: d1
        },
        {
          name: 'Something Else',
          data: d2
        }
      ]
    },
    fetchLineChartData(){
      this.lineChartData = [
        [1,113],
        [2,200],
        [3,178],
        [4,649],
        [5,332],
        [6,293],
        [7,723]
      ]
    }
  },
  mounted () {
    this.fetchOrgInfo();
    this.fetchTableData();
    this.fetchTimeSeriesData();
    this.fetchLineChartData();
  },
  components: {
    Sidebar,
    Nav,
    Table,
    DataTable,
    TimeSeries,
    BasicChart
  }
};
</script>


<style scoped>
.floating-container {
  width: 1200px;
  display: inline-block;
  text-align: left;
}

.chart-container{
  display: inline-block;
  width: calc(50% - 42px);
  margin: 20px;
}

.app {
  text-align: center;
  margin-top: 20px;
}

.chart-container.table {
  width: calc(100% - 40px);
}
</style>



// WEBPACK FOOTER //
// src/components/Admin.vue